import React from 'react';
import Footer from '../components/Footer';
import GamePage from '../components/GamePage';

import BalloonsOdyssey_Img01 from '../images/balloonsodyssey/balloonsodyssey-store-04.png';


export default function BalloonsOdyssey_Store04() {
  return (
    <>
      <GamePage
        name="Balloons Odyssey: store skins tab"
        description="Skins you can buy via store in Balloons Odyssey."
        images={[BalloonsOdyssey_Img01]}
        conclusion="Already implemented in the game Balloons Odyssey."
      />
      <Footer />
    </>
  );
}